import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingFileViewerComponent } from './floating-file-viewer.component';
import { MaterialModule } from "../../material/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisbursDtlsCompModule } from "src/app/modules/Disbursment_modules/disbursment/disburs-dtls-comp/disburs-dtls-comp.module";

@NgModule({
  declarations: [FloatingFileViewerComponent],
  imports: [CommonModule, MaterialModule, FormsModule, DisbursDtlsCompModule],
  exports: [FloatingFileViewerComponent],
})
export class FloatingFileViewerModule {}
